import { PROYECT } from "services/api";
import { reportSalesCategoryTypes } from "redux/reducers/Reports/reportSalesCategory/types";
import { saveAs } from 'file-saver';
import axios from "axios";
import { setSnackbar, startRequestComp,  stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";
const { SET_REPORT_SALES_CATEGORY_FILTERS } = reportSalesCategoryTypes


export const getReportSalesCategoryAction = ({ startDate, endDate, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    const auth = { headers: { authorization: token } };
    const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/notes/sales-by-category/report?start=${startDate}&end=${endDate}&idStation=${station.id}&pdf=${isPdf}`;
    const fileName = `Reporte_Venta_Categoría_${station.name}_${startDate}_${endDate}.${isPdf ? `pdf` : 'xlsx'}`;

    dispatch(startRequestComp('loadingReportSalesCategory'))
    const access = {
      url: reportUrl,
      method: 'GET',
      responseType: 'blob',
      ...auth
    }
    try {
      const pdf = await axios(access)
      saveAs(pdf.data, fileName)
      dispatch(setSnackbar(`${isPdf ? `PDF` : `Excel`} Descargado con éxito`, "success"))
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)))
    } finally {
      dispatch(stopRequestComp('loadingReportSalesCategory'))
    }
  }
}

export const setReportSalesCategoryFilters = (key = "", value) => {
  return {
    type: SET_REPORT_SALES_CATEGORY_FILTERS,
    payload: { value, key }
  }
}
